// import { Button } from '../../components/ui/button'
// import { Card } from '../../components/ui/card'
// import React, { useEffect } from 'react'
// import { zodResolver } from '@hookform/resolvers/zod'
// import { useForm } from 'react-hook-form'
// import img from '../../pics/landImg.jpeg'
// import {
//   Form,
//   FormControl,
//   FormDescription,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage
// } from '../../components/ui/form'
// import { Input } from '../../components/ui/input'
// import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
// import useAuth from '../../hooks/useAuth'
// import { ClipLoader } from 'react-spinners'
// import { setAuth } from '../../store/features/authSlice'
// import { useDispatch } from 'react-redux'
// import { loginSchema } from './validators'
// import { useLogin } from '../../migration-api/api-hooks/auth'
// import { toast } from '../../components/ui/use-toast'

// function Login () {
//   const dispatch = useDispatch()
//   const navigate = useNavigate()

//   const location = useLocation()
//   const { auth } = useAuth()
//   const form = useForm({
//     resolver: zodResolver(loginSchema),
//     defaultValues: {
//       email: '',
//       password: ''
//     }
//   })

//   const from = location.state?.from?.pathname || '/pages'

//   const { login, isLoading } = useLogin({
//     onSuccess: data => {
//       toast({
//         variant: 'success',
//         title: 'Success',
//         description: 'Login success',
//       })
// 	  // console.log('accesssss', data?.data?.tokens?.accessToken)
// 	  // console.log('user', data)
// 	  // console.log('provider', data)
//       dispatch(
//         setAuth({
//           accessToken: data?.data?.tokens?.accessToken,
//           refreshToken: data?.data?.tokens?.refreshToken,
//           user: data?.data?.user,
//           providerToken: data?.data?.providerToken,
//           login: true
//         })
//       )
//       sessionStorage.setItem('login', true)
//       navigate(from, { replace: true })
//     },
//     onError: error => {
//       if (error.code !== 'ERR_NETWORK') {
//         console.log('err_res',error)
//         toast({
//           variant: 'destructive',
//           title: 'Error',
//            description: `${
//           error?.response?.data?.message || 'Invalid Email or Password'
//         }`
//         })
//       } else {
//         console.log(error)
//         toast({
//           variant: 'destructive',
//           title: 'Error',
//           description: 'Please Check Your Network'
//         })
//       }
//     }
//   })

//   useEffect(() => {
//     navigator.permissions.query({ name: 'geolocation' }).then(resp => {
//       console.log('geting location ......................')
//       if (resp.state === 'granted' || resp.state === 'prompt') {
//         console.log('granted')
//         if (navigator.geolocation) {
//           navigator.geolocation.getCurrentPosition(success, error)
//         }
//       } else if (resp.state === 'denied') {
//         toast({
//           variant: 'destructive',
//           title: 'Error',
//           description: 'Please application need to access your location'
//         })
//         if (navigator.geolocation) {
//           navigator.geolocation.getCurrentPosition(success, error)
//         }
//       }
//     })

//     function success (position) {}

//     function error (err) {
//       console.log(err)
//       toast({
//         variant: 'destructive',
//         title: 'Error',
//         description: 'Please application need to access your location'
//       })
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [])

//   function onSubmit (values) {
//     login(values)
//   }

//   if (auth?.login === true) {
//     return <Navigate to='/pages' />
//   } else
//     return (
//       <div className='w-full h-full'>
//         <div className=' pl-24  pt-10'>
//           <img src='/sproxillogo.png' alt='' className='w-[120px]' />
//         </div>
//         <div className='flex flex-col'>
//           <div className='h-[80vh] flex flex-col gap-[10px] justify-center items-center'>
//             <Card className=' h-[fit-content] w-[350px] p-[20px] min-w-[230px]'>
//               <h1 className='font-extrabold text-xl'>Welcome back! </h1>
//               <h4 className=' text-xs'>Great to have you. Happy Tracking</h4>
//               <br />
//               <Form {...form}>
//                 <form
//                   onSubmit={form.handleSubmit(onSubmit)}
//                   className='space-y-8'
//                   autoComplete='off'
//                 >
//                   <FormField
//                     control={form.control}
//                     name='email'
//                     render={({ field }) => (
//                       <FormItem>
//                         <FormLabel>Email</FormLabel>
//                         <FormControl>
//                           <Input placeholder='johndoe@gmail.com' {...field} />
//                         </FormControl>
//                         <FormDescription>
//                           This is your registered email.
//                         </FormDescription>
//                         <FormMessage />
//                       </FormItem>
//                     )}
//                   />
//                   <FormField
//                     control={form.control}
//                     name='password'
//                     render={({ field }) => (
//                       <FormItem>
//                         <FormLabel>Password</FormLabel>
//                         <FormControl>
//                           <Input
//                             placeholder=''
//                             {...field}
//                             type='password'
//                             value={undefined}
//                             isPassword
//                             autoComplete='password'
//                           />
//                         </FormControl>
//                         <FormMessage />
//                         <Link
//                           to={'/forgot-password'}
//                           className='block w-fit mt-3 text-primary'
//                         >
//                           forgot password?
//                         </Link>
//                       </FormItem>
//                     )}
//                   />

//                   <Button type='submit' variant='' disabled={isLoading}>
//                     {isLoading ? (
//                       <span className='mx-[20px]'>
//                         <ClipLoader color='primary' size={20} />
//                       </span>
//                     ) : (
//                       <span> SignIn</span>
//                     )}
//                   </Button>
//                 </form>
//               </Form>
//             </Card>
//             <div className=' text-primary text-[9px]'>
//               Copyright &copy; {new Date().getFullYear()}
//             </div>
//           </div>
//           <div className='h-[5vh] flex items-end w-full justify-center'>
//             <img src={img} alt='' className=' md:w-[65%] ' />
//           </div>
//         </div>
//       </div>
//     )
// }

// export default Login



import { Button } from '../../components/ui/button'
import { Card } from '../../components/ui/card'
import React, { useEffect, useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import img from '../../pics/landImg.jpeg'
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '../../components/ui/form'
import { Input } from '../../components/ui/input'
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import { ClipLoader } from 'react-spinners'
import { setAuth } from '../../store/features/authSlice'
import { useDispatch } from 'react-redux'
import { loginSchema } from './validators'
import { useLogin } from '../../migration-api/api-hooks/auth'
import { toast } from '../../components/ui/use-toast'
import TradingPartnerClientSelector from '../../components/Tradingpartnerclientselector';

function Login () {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [showClientSelector, setShowClientSelector] = useState(false)
  const [tradingPartnerUser, setTradingPartnerUser] = useState(null)

  const location = useLocation()
  const { auth } = useAuth()
  const form = useForm({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: '',
      password: ''
    }
  })

  const from = location.state?.from?.pathname || '/pages'

  const { login, isLoading } = useLogin({
    onSuccess: data => {
      const userRole = data?.data?.user?.role

      // Check if user is a trading partner
      if (userRole === 'TRADING_PARTNER') {
        toast({
          variant: 'success',
          title: 'Success',
          description: 'Login successful. Please select a client to continue.',
        })

        dispatch(
          setAuth({
            accessToken: data?.data?.tokens?.accessToken,
            refreshToken: data?.data?.tokens?.refreshToken,
            user: data?.data?.user,
          })
        )
        
        setTradingPartnerUser(data?.data?.user)
        setShowClientSelector(true)
      } else {
        // Normal login flow for other roles
        toast({
          variant: 'success',
          title: 'Success',
          description: 'Login success',
        })
        
        dispatch(
          setAuth({
            accessToken: data?.data?.tokens?.accessToken,
            refreshToken: data?.data?.tokens?.refreshToken,
            user: data?.data?.user,
            providerToken: data?.data?.providerToken,
            login: true
          })
        )
        sessionStorage.setItem('login', true)
        navigate(from, { replace: true })
      }
    },
    onError: error => {
      if (error.code !== 'ERR_NETWORK') {
        console.log('err_res', error)
        toast({
          variant: 'destructive',
          title: 'Error',
          description: `${
            error?.response?.data?.message || 'Invalid Email or Password'
          }`
        })
      } else {
        console.log(error)
        toast({
          variant: 'destructive',
          title: 'Error',
          description: 'Please Check Your Network'
        })
      }
    }
  })

  useEffect(() => {
    navigator.permissions.query({ name: 'geolocation' }).then(resp => {
      console.log('geting location ......................')
      if (resp.state === 'granted' || resp.state === 'prompt') {
        console.log('granted')
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(success, error)
        }
      } else if (resp.state === 'denied') {
        toast({
          variant: 'destructive',
          title: 'Error',
          description: 'Please application need to access your location'
        })
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(success, error)
        }
      }
    })

    function success (position) {}

    function error (err) {
      console.log(err)
      toast({
        variant: 'destructive',
        title: 'Error',
        description: 'Please application need to access your location'
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onSubmit (values) {
    login(values)
  }

  if (auth?.login === true) {
    return <Navigate to='/pages' />
  }

  // Show client selector for trading partners
  if (showClientSelector && tradingPartnerUser) {
    return <TradingPartnerClientSelector user={tradingPartnerUser} />
  }

  // Normal login screen
  return (
    <div className='w-full h-full'>
      <div className=' pl-24  pt-10'>
        <img src='/sproxillogo.png' alt='' className='w-[120px]' />
      </div>
      <div className='flex flex-col'>
        <div className='h-[80vh] flex flex-col gap-[10px] justify-center items-center'>
          <Card className=' h-[fit-content] w-[350px] p-[20px] min-w-[230px]'>
            <h1 className='font-extrabold text-xl'>Welcome back! </h1>
            <h4 className=' text-xs'>Great to have you. Happy Tracking</h4>
            <br />
            <Form {...form}>
              <form
                onSubmit={form.handleSubmit(onSubmit)}
                className='space-y-8'
                autoComplete='off'
              >
                <FormField
                  control={form.control}
                  name='email'
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Email</FormLabel>
                      <FormControl>
                        <Input placeholder='johndoe@gmail.com' {...field} />
                      </FormControl>
                      <FormDescription>
                        This is your registered email.
                      </FormDescription>
                      <FormMessage />
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name='password'
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Password</FormLabel>
                      <FormControl>
                        <Input
                          placeholder=''
                          {...field}
                          type='password'
                          value={undefined}
                          isPassword
                          autoComplete='password'
                        />
                      </FormControl>
                      <FormMessage />
                      <Link
                        to={'/forgot-password'}
                        className='block w-fit mt-3 text-primary'
                      >
                        forgot password?
                      </Link>
                    </FormItem>
                  )}
                />

                <Button type='submit' variant='' disabled={isLoading}>
                  {isLoading ? (
                    <span className='mx-[20px]'>
                      <ClipLoader color='primary' size={20} />
                    </span>
                  ) : (
                    <span> SignIn</span>
                  )}
                </Button>
              </form>
            </Form>
          </Card>
          <div className=' text-primary text-[9px]'>
            Copyright &copy; {new Date().getFullYear()}
          </div>
        </div>
        <div className='h-[5vh] flex items-end w-full justify-center'>
          <img src={img} alt='' className=' md:w-[65%] ' />
        </div>
      </div>
    </div>
  )
}

export default Login
